import { apiClient } from '.';
import { UserDiscountCouponSearchQuery } from '@models/user-discount-coupon';

export const searchUserDiscountCoupons = async (query: UserDiscountCouponSearchQuery) => {
  return apiClient.get('/admin/v1/user-discount-coupons', { params: query });
};
